import { useCallback, useState } from 'react';
import { PersonalizationContextProvider } from 'personalization-lib/contexts/PersonalizationContext';
import { UsageTrackerProvider } from 'personalization-lib/contexts/UsageTrackerContext';
import CreateVariantPanel from 'personalization-lib/components/variantCreation/CreateVariantPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PersonalizationProvider = ({
  tracker,
  appName,
  screen,
  children
}) => {
  const [panelProps, setPanelProps] = useState(null);
  const isPanelOpen = panelProps !== null;
  const openPanel = useCallback(props => setPanelProps(props), [setPanelProps]);
  const closePanel = useCallback(() => setPanelProps(null), [setPanelProps]);
  return /*#__PURE__*/_jsx(UsageTrackerProvider, {
    tracker: tracker,
    appName: appName,
    screen: screen,
    children: /*#__PURE__*/_jsxs(PersonalizationContextProvider, {
      openPanel: openPanel,
      isPanelOpen: isPanelOpen,
      children: [children, isPanelOpen && /*#__PURE__*/_jsx(CreateVariantPanel, Object.assign({
        onClose: closePanel
      }, panelProps))]
    })
  });
};
export default PersonalizationProvider;